import React from 'react'

export const RightChevron: React.FC<React.SVGProps<SVGSVGElement>> = ({ width, height, ...restProps }) => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_11367_17465'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='20'
        height='20'
      >
        <rect width='20' height='20' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_11367_17465)'>
        <path
          d='M6.87539 15.1249C6.72539 14.9749 6.65039 14.7999 6.65039 14.5999C6.65039 14.3999 6.72539 14.2249 6.87539 14.0749L10.9504 9.9999L6.87539 5.9249C6.72539 5.7749 6.65039 5.5999 6.65039 5.3999C6.65039 5.1999 6.72539 5.0249 6.87539 4.8749C7.02539 4.7249 7.20039 4.6499 7.40039 4.6499C7.60039 4.6499 7.77539 4.7249 7.92539 4.8749L12.4254 9.3749C12.5087 9.45824 12.5714 9.5539 12.6134 9.6619C12.6547 9.77057 12.6754 9.88324 12.6754 9.9999C12.6754 10.1166 12.6547 10.2289 12.6134 10.3369C12.5714 10.4456 12.5087 10.5416 12.4254 10.6249L7.92539 15.1249C7.77539 15.2749 7.60039 15.3499 7.40039 15.3499C7.20039 15.3499 7.02539 15.2749 6.87539 15.1249Z'
          fill='#0F6BFF'
        />
      </g>
    </svg>
  )
}

export default RightChevron
